module.exports = __webpack_public_path__ + "img/admin-menu.7fdb7152.svg";